module.exports = __webpack_public_path__ + "static/media/azure.12e3dac8.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/azure.ico
// module id = 71
// module chunks = 0